class BESSAppResetPassword extends BESSAppBase {

    constructor() {
        super();
        if ($('.app-user-reset-password-required').length > 0) {
            this.modal = new BESSAppResetPasswordModel();
            this.modal.open();
        }
    }
}

class BESSAppResetPasswordModel extends BESSAppModal {

    constructor() {
        super('app-reset-password-form-modal');
        this.inputPassword = this.view.node.find('#input-password');
        this.inputConfirmPassword = this.view.node.find('#input-confirm-password');
        this.updatePasswordBtn = this.view.node.find('.app-update-password');
        this.form = this.view.node.find('form');
        this.form.submit(this.#onUpdatePassword.bind(this));
    }

    #onUpdatePassword(e) {
        e.preventDefault();
        let password = this.inputPassword.val();
        let confirmPassword = this.inputConfirmPassword.val();
        let passwordsMatch = password === confirmPassword;
        $('.app-passwords-dont-match').showIf(!passwordsMatch);
        if (passwordsMatch) {
            this.updatePasswordBtn.disableControl();
            this.updatePasswordBtn.addClass('app-saving');
            BESSApp.instance.services.api.auth.updatePassword(
                null,
                password,
                this.#onUpdatePasswordSuccess.bind(this),
                this.#onUpdatePasswordFail.bind(this));
        }
    }

    #onUpdatePasswordSuccess() {
        this.close();
    }

    #onUpdatePasswordFail(reason) {
        $('.app-passwords-is-invalid').text(reason).show();
    }
}

